import { Injectable } from '@angular/core';
import { PluginSlot } from '../classes/plugin-slot';
import { Subject } from 'rxjs/Subject';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Plugin } from '../classes/plugin';
import { Collection } from '../../support/collection/collection';

@Injectable()
export class PluginService {

    /**
     * The registered plugins.
     *
     * @type {Collection}
     */
    public slots: Collection = new Collection;

    /**
     * The observer that watches for changes in the registered slots.
     *
     * @type {Subject<any>}
     */
    public observer: ReplaySubject<any> = new ReplaySubject;

    /**
     * Add a new modal to the modals collection.
     *
     * @param slot
     * @param name
     * @param component
     * @param order
     * @param data
     * @param options
     * @param template
     * @returns {Plugin}
     */
    public add(slot: string, name: string, component: any, order: number = 100, data: any = {}, options: { [key: string]: any } = {}, template?: any): Plugin {
        let plugin = new Plugin(name, component, order, data, options, template);

        if (data && data.inputs) {
            plugin.input(data.inputs);
        }
        if (data && data.outputs) {
            plugin.output(data.outputs);
        }

        plugin = this.slot(slot).add(plugin);

        this.observer.next({
            add: plugin
        });

        return plugin;
    }

    /**
     * Get the modal with the given name from the given slot.
     *
     * @param slot
     * @param name
     * @returns {null}
     */
    public get(slot: string, name: string): Plugin {
        return this.slot(slot).get(name);
    }

    /**
     * Remove the modal with the given name from the given slot.
     *
     * @param slot
     * @param name
     */
    public remove(slot: string, name: string) {
        this.observer.next({
            remove: this.get(slot, name),
        });

        this.slot(slot).remove(name);
    }

    /**
     * Get the plugin slot with the given name. If no slot is found a new slot will be created
     * with the given name.
     *
     * @returns {PluginSlot}
     * @param name
     */
    public slot(name: string): PluginSlot {
        if (!this.slots.find('name', name)) {
            this.slots.push(new PluginSlot(name));
        }

        return this.slots.find('name', name);
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/plugins/services/plugin.service.ts